import type { PropsWithChildren } from "react";

import * as AssetsRouter from "@scripts/generated/routers/assetsRouter";
import { AnchorWithChildren } from "@scripts/react/components/Anchor";
import { useConfig } from "@scripts/react/context/Config";
import { urlInterface } from "@scripts/routes/urlInterface";

import { MinimalFooter, type MinimalFooterProps } from "@scripts-ssr/components/MinimalLayout";

import { klass, klassProp } from "../util/classnames";

export const MinimalContainer = (props: PropsWithChildren<MinimalFooterProps>) => {
  const config = useConfig();
  return (
    <div {...klass("content-container", "minimal-container", "login")}>
      <div {...klass("minimal-form-container", "d-flex")}>
        <div {...klass("bl-logo-container")}>
          <AnchorWithChildren
            aria-label="BondLink Home Page"
            externalLinkLocation="none"
            klass={klassProp("no-decoration", "flex-grow")}
            route={{
              title: "BondLink Home Page",
              route: urlInterface("GET", config.baseUrl),
            }}
            target={"_self"}
          >
            <img
              src={AssetsRouter.assetImgLogosBondlink2019Svg().url}
              alt="BondLink Logo"
              {...klass("bl-logo")}
            />
          </AnchorWithChildren>
        </div>
        {props.children}
      </div>
      <MinimalFooter hideTermsLink={props.hideTermsLink} />
    </div>
  );
};
